export const system = {
    'DateCodeGenie Portal': 2,
    'DateCodeGenie App': 1,
    /*'AFS': 3,
    'Task Manager': 4,
    'Admin Settings': 5*/
};